// ============================================
// Creator Events - Image (ES6)
// 이미지 관련 모달 이벤트
// ============================================

import {
  openImageGenModal, closeImageGenModal, confirmImageGen,
  openImageModal, closeImageModal, switchImageTab,
  handleImageUpload, generateImages, updateImageCost,
  closeImageDetail, applyImage, downloadImage, deleteGeneratedImage,
  // 이미지 변형 관련
  openSourceImageSheet, closeSourceImageSheet, uploadSourceImage,
  updateTransformCost, transformImage, openTransformResultDetail
} from '../index.js';
import { openLibraryForTransformSource, handleGenModeChange } from '../image-gallery.js';

// ============================================
// 이미지 자동생성 모달 이벤트
// ============================================

export function initImageGenModalEvents() {
  const modal = document.getElementById('imageGenModal');
  if (!modal) return;

  // 뒤로가기 버튼
  modal.querySelector('.detail-back-btn')?.addEventListener('click', closeImageGenModal);

  // 생성하기 버튼
  modal.querySelector('.autofill-submit-btn')?.addEventListener('click', confirmImageGen);
}

// ============================================
// 이미지 선택 모달 이벤트
// ============================================

export function initImageSelectionModalEvents() {
  const modal = document.getElementById('imageSelectionModal');
  if (!modal) return;

  // 뒤로가기 버튼
  modal.querySelector('.detail-back-btn')?.addEventListener('click', closeImageModal);

  // 탭 버튼 (이벤트 위임)
  modal.querySelector('.image-modal-tabs')?.addEventListener('click', (e) => {
    const tab = e.target.closest('.image-modal-tab');
    if (tab) {
      const tabName = tab.dataset.imageTab;
      if (tabName) switchImageTab(tabName);
    }
  });

  // 이미지 개수 선택
  document.getElementById('imageGenCount')?.addEventListener('change', updateImageCost);

  // 이미지 생성 모드 라디오 버튼
  document.querySelectorAll('input[name="imageGenMode"]').forEach(radio => {
    radio.addEventListener('change', handleGenModeChange);
  });

  // 이미지 생성 버튼 (생성 탭만)
  const genTab = document.getElementById('imageTabGenerate');
  genTab?.querySelector('.image-gen-btn')?.addEventListener('click', generateImages);

  // 파일 업로드
  document.getElementById('imageFileInput')?.addEventListener('change', (e) => handleImageUpload(e));

  // ============================================
  // 이미지 변형 탭 이벤트
  // ============================================

  // 변형 개수 선택
  document.getElementById('transformCount')?.addEventListener('change', updateTransformCost);

  // 변형 탭 이벤트 위임
  const transformTab = document.getElementById('imageTabTransform');
  transformTab?.addEventListener('click', (e) => {
    const actionEl = e.target.closest('[data-action]');
    if (!actionEl) return;

    const action = actionEl.dataset.action;
    const index = actionEl.dataset.index;

    switch (action) {
      case 'openSourceImageSheet':
        openSourceImageSheet();
        break;
      case 'transformImage':
        transformImage();
        break;
      case 'openTransformResult':
        if (index !== undefined) {
          openTransformResultDetail(parseInt(index));
        }
        break;
    }
  });

  // 소스 이미지 파일 입력
  document.getElementById('sourceImageFileInput')?.addEventListener('change', (e) => uploadSourceImage(e));

  // 바텀시트 이벤트 위임
  const sheet = document.getElementById('sourceImageSheet');
  sheet?.addEventListener('click', (e) => {
    const action = e.target.closest('[data-action]')?.dataset.action;
    switch (action) {
      case 'closeSourceImageSheet':
        closeSourceImageSheet();
        break;
      case 'uploadSourceImage':
        document.getElementById('sourceImageFileInput')?.click();
        break;
      case 'selectFromLibrary':
        openLibraryForTransformSource();
        break;
    }
  });
}

// ============================================
// 이미지 상세 모달 이벤트
// ============================================

export function initImageDetailModalEvents() {
  const modal = document.getElementById('imageDetailModal');
  if (!modal) return;

  // 다운로드 버튼
  modal.querySelector('.image-detail-btn-small:not(.danger)')?.addEventListener('click', downloadImage);

  // 삭제 버튼
  modal.querySelector('.image-detail-btn-small.danger')?.addEventListener('click', deleteGeneratedImage);

  // 닫기 버튼
  modal.querySelector('.image-detail-close')?.addEventListener('click', closeImageDetail);

  // 적용 버튼
  modal.querySelector('.image-detail-apply-btn')?.addEventListener('click', applyImage);
}
